











import { Component, Vue } from 'vue-property-decorator';
import MsisdnBalances from "@/components/MsisdnBalances.vue";
import FraudCaseTable from "@/components/FraudCaseTable.vue";
import TransactionsTable from "@/components/TransactionsTable.vue";
import {TransactionFilter} from "@/model/transaction-filter";
import TransactionsCriteriaPicker from "@/components/TransactionsCriteriaPicker.vue";
import {CriteriaType, FilterCriteria} from "@/model/filter-criteria";
import {fraudCaseService} from "@/services/fraud-case";
import {FraudCase} from "@/model/fraud-case";

@Component({
  components: {TransactionsCriteriaPicker, TransactionsTable, FraudCaseTable}
})
export default class FraudCases extends Vue {

  overlay = false;

  criteriaOptions: CriteriaType[] =  [
    CriteriaType.MSISDN,
    CriteriaType.USER_ID,
    CriteriaType.CREDIT_CARD_TOKEN,
    CriteriaType.PAYPAL_PAYER_ID,
    CriteriaType.FRAUD_CASE_ID
  ];

  caseIds: string[] = []

  cases: FraudCase[] = []

  async refreshRelated(criterias: FilterCriteria[]) {
    this.overlay = true;
    let fraudCases: FraudCase[] = [];
    for (const t of criterias) {
      switch(t.type) {
        case CriteriaType.MSISDN:
          fraudCases = fraudCases.concat((await fraudCaseService.getFraudCases(0, 10000, t.value, '', '', '')).content);
          break;
        case CriteriaType.USER_ID:
          fraudCases = fraudCases.concat((await fraudCaseService.getFraudCases(0, 10000, '', t.value, '', '')).content);
          break;
        case CriteriaType.CREDIT_CARD_TOKEN:
          fraudCases = fraudCases.concat((await fraudCaseService.getFraudCases(0, 10000, '', '', t.value, '')).content);
          break;
        case CriteriaType.PAYPAL_PAYER_ID:
          fraudCases = fraudCases.concat((await fraudCaseService.getFraudCases(0, 10000, '', '', '', t.value)).content);
          break;
        case CriteriaType.FRAUD_CASE_ID:
          fraudCases = fraudCases.concat((await fraudCaseService.getFraudCaseById(t.value)));
          break;
      }
    }
    this.caseIds = [...new Set(fraudCases.map(c => c.id.toString()))];
    this.cases = this.caseIds.map( id => {
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      return fraudCases.find( value =>  value.id.toString() === id)!
    })
    this.overlay = false;
  }
}
